module.exports = __webpack_public_path__ + "b24f3966.png";